<template>
	<div id="systemrole">
		<HrrBreadcrumb PMname="用户权限管理" CMname="角色管理" />
		<HrrDetailLayout>
			<template slot="head" >
				{{title}}
			</template>
			<template slot="Form" >
				<el-form status-icon :model="form" ref="form" :rules="rules" label-width="100px" class="el-form-module" :hide-required-asterisk="isView" >
					<el-form-item label="角色名称：" prop="roleName">
						<el-input v-model="form.roleName" v-if="isAdd||isEdit"></el-input>
						<span v-if="isView">
							{{form.roleName}}
						</span>
					</el-form-item>
					<el-form-item label="角色描述：" prop="roleDesc">
						<el-input v-model="form.roleDesc" v-if="isAdd||isEdit" type="textarea" :rows="3" ></el-input>
						<span v-if="isView">
							{{form.roleDesc}}
						</span>
					</el-form-item>
					<el-form-item label="状态：" prop="status">
						<el-radio-group v-model="form.status" v-if="isAdd||isEdit" >
							<el-radio :label="1" :disabled="isView">启用</el-radio>
							<el-radio :label="0" :disabled="isView">禁用</el-radio>
						</el-radio-group>
                        <span v-if="isView">
                           {{form.status_str}}
                        </span>
					</el-form-item>
				</el-form>
			</template>
			<template slot="buttons" >
				<el-button type="primary" @click="submitMForm('form')" v-if="isAdd||isEdit">提 交</el-button>
				<el-button  @click="resetMForm('form')" v-if="isAdd||isEdit">重 置</el-button>
				<el-button type="info" @click="returnMForm()" >返 回</el-button>
			</template>
		</HrrDetailLayout>
	</div>
</template>
<script>
	export default {
		name: 'roledetail',
		data(){
			return{
				form:{
					roleName:"",
                    roleDesc:"",
                    status:1,
                    status_str:""
				},
				rules:{
					roleName:[ { required: true, message: '请输入角色名称' , trigger: 'blur'}]
				},
				title:"",
				isEdit:false,
				isAdd:false,
				isView:false,
			}
		},
		methods:{
			submitMForm:function(formName){
                this.$refs[formName].validate((valid) =>{
					if (valid) {
						var loading = this.$loading({
							lock: true,
							text: '提交中...',
							spinner: 'el-icon-loading',
							background: 'rgba(0, 0, 0, 0.7)'
						});
						var Vuethis=this;
						var apiUrl=this.isAdd?this.$api.system.role:this.$api.system.role+"/"+this.form.roleId;
						var m=this.isAdd?"Post":"Put";
						this.$hrraxios({
							 method: m,
							 url: apiUrl,
							 data: this.form
						})
						.then(function(response){
							loading.close();
							var data=response.data;
							if(data.Success==true)
							{
								Vuethis.$alert("提交成功！",{callback:action=>{
									Vuethis.$router.push({path:'/system/role/'});
								}});
							}else{
								Vuethis.$message({message:data.Prompt,type:"error"});
							}
						}).catch(function(error){
							loading.close();
							console.log(error);
						})
					} else {
						return false;
					}
				});
			},
			resetMForm:function(formName) {
				this.$refs[formName].resetFields();
			},
			returnMForm:function(){
				this.$router.go(-1);
			},
			initData:function(){
				this.isView=false;
				this.isEdit=false;
				this.isAdd=false;
				var Hrrtype=this.$route.params.type; //类型
				var row=this.$route.meta.row;
				var info="角色信息";
				if(Hrrtype!="add"){
					this.form=row;
					this.$route.meta.row=null;
				}
				if(Hrrtype=="view"){
					this.title="查看"+info;
					this.isView=true;
				}
				if(Hrrtype=="modify"){
					this.title="编辑"+info;
					this.isEdit=true;

				}
				if(Hrrtype=="add"){
					this.title="新增"+info;
					this.isAdd=true;
				}
			}
		},
		created:function(){
	        this.$route.meta.row!=undefined?localStorage.setItem("row",JSON.stringify(this.$route.meta.row)):"";
        	localStorage.getItem("row")!=undefined? this.$route.meta.row=JSON.parse(localStorage.getItem("row")):"";
			this.initData();
		}
	}
</script>
<style>
.el-form-module{width:500px;}
</style>
